import React, { useState } from 'react'
import { CCol, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import './table.css'
import { wtFormatMoneyRoundData, wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import { Link } from 'react-router-dom'
import { wtConvertHourValue } from 'src/helpers/commons/moment'
import { EMPLOYEE_TYPE_NAME } from '../Employees/Employees'

export default function DataReportTable({ reportData, setReportData
}) {
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })

  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }

  const getTotal = () => {
    let total = 0;
    reportData.map((item) => {
      total += item.total_amount
    });
    return total;
  }

  return (
    <CRow>
      <CCol md={12}>
      <div className="table-container">
        <table className="table table-bordered data-table">
          <thead class="thead-dark" style={{ backgroundColor: '#e8e9eb' }}>
            <tr>
              <th onClick={() => sortTable('id')}>Sr</th>
              <th onClick={() => sortTable('id')}>
                ID{' '}
                {sortedKey === 'id' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th style={{width:'10%'}} onClick={() => sortTable('full_name')}>
                Full Name
                {sortedKey === 'full_name' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th style={{width:'10%'}} onClick={() => sortTable('employee.employee_type')}>
                Employee Type
                {sortedKey === 'employee.employee_type' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th style={{width:'10%'}} onClick={() => sortTable('designation.name')}>
                Designation
                {sortedKey === 'designation.name' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('department.name')}>
                Department
                {sortedKey === 'department.name' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('per')}>
                PER
                {sortedKey === 'per' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('per_bonus')}>
                Bonus
                {sortedKey === 'per_bonus' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('acr')}>
                acr
                {sortedKey === 'acr' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('acr_bonus')}>
                Bonus
                {sortedKey === 'acr_bonus' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('total')}>
                total
                {sortedKey === 'total' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('warnings')}>
                warnings
                {sortedKey === 'warnings' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('warning_deduction')}>
                Warning<br />Deduction
                {sortedKey === 'warning_deduction' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('warning_total')}>
                Warning<br /> Total
                {sortedKey === 'warning_total' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('absents')}>
                Absents
                {sortedKey === 'absents' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('absent_bonus')}>
                Absent <br /> Bonus
                {sortedKey === 'absent_bonus' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('absent_total')}>
                absent <br /> total
                {sortedKey === 'absent_total' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('lfp')}>
                LFP
                {sortedKey === 'lfp' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('lfp_bonus')}>
                LFP <br /> Bonus
                {sortedKey === 'lfp_bonus' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('bonus_on_merit')}>
                Bonus On <br />Merit
                {sortedKey === 'bonus_on_merit' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('reporting_officer_bonuses')}>
                Reporting <br />Officer <br />Bonuses
                {sortedKey === 'reporting_officer_bonuses' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('ceo_bonuses')}>
                CEO & MD WIL <br /> Bonuses
                {sortedKey === 'ceo_bonuses' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('total_bonuses')}>
                Total Bonuses
                {sortedKey === 'total_bonuses' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('salary')}>
                Salary
                {sortedKey === 'salary' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('total_amount')}>
                Total Amount
                {sortedKey === 'total_amount' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('section')}>
                Section
                {sortedKey === 'section' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>
              <th onClick={() => sortTable('remarks')}>
                Remarks
                {sortedKey === 'remarks' && (
                  <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
                )}
              </th>

            </tr>
          </thead>
          <tbody>
            {reportData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td style={{ color: 'blue' }}>
                  <Link
                    to={`/employee-profile?id=${item.employee_id}&tab=emp_attendance`}
                    target="_blank"
                  >
                    {item.employee.id}
                  </Link>
                </td>
                <td style={{ color: 'blue' }}>
                  <Link
                    to={`/employee-profile?id=${item.employee_id}&tab=emp_attendance`}
                    target="_blank"
                  >
                    {item.employee.full_name}
                  </Link>
                </td>
                <td>{EMPLOYEE_TYPE_NAME[item.employee.employee_type]}</td>
                <td>{item.employee.designation.name}</td>
                <td>{item.employee.department.name}</td>
                <td>{item.per}</td>
                <td>{item.per_bonus}</td>
                <td>{item.acr}</td>
                <td>{item.acr_bonus}</td>
                <td>{item.total}</td>
                <td>{item.warnings}</td>
                <td>{item.warning_deduction}</td>
                <td>{item.warning_total}</td>
                <td>{item.absents}</td>
                <td>{item.absent_bonus}</td>
                <td>{item.absent_total}</td>
                <td>{item.lfp}</td>
                <td>{item.lfp_bonus}</td>
                <td>{item.bonus_on_merit}</td>
                <td>{item.reporting_officer_bonuses}</td>
                <td>{item.ceo_bonuses}</td>
                <td>{item.total_bonuses}</td>
                <td>{wtFormatMoneyRoundData(item.salary,"",false)}</td>
                <td>{wtFormatMoneyRoundData(item.total_amount,"",false)}</td>
                <td>{item.section}</td>
                <td>{item.remarks}</td>
              </tr>
            ))}
            <tr>
              <th colSpan={24} style={{ textAlign: 'center' }}>Total Amount</th>
              <th>{wtFormatMoneyRoundData(getTotal(), "", false)}</th>
            </tr>

          </tbody>
        </table>
        </div>
      </CCol>
    </CRow>
  )
}
